/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import { SearchCriteria } from '../SearchCriteria';
import { DrillDownType } from '../DrillDownType';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MTooltip from '@material-ui/core/Tooltip';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import { ChartInfo } from '../../components/ChartInfo';
import { Balance, useTrustBalanceByAgeQuery } from './hooks/useTrustBalanceByAgeQuery';
import { useCurrencySymbol } from '../../hooks/useCurrencySymbol';
import { useHomeCountry } from '../../hooks/useHomeCountry';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvBarDatasetStyle, rvChartAnimation, rvValueAxisStyle, rvCategoryAxisStyle, rvTooltipStyle, isChartDataEmpty } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartLimitNote } from '../ChartLimitNote';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        titleBy: {
            paddingTop: '10px',
            fontSize: 16,
            fontFamily: 'inherit',
            fontWeight: 600,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
    }),
);

interface TrustBalanceByAgeChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    showAllRecords?: boolean;
}

interface ChartState {
    balances: Balance[];
    total: number;
    symbol: string;
    homeCountry: string;
}

export const TrustBalanceByAgeChart: React.FC<TrustBalanceByAgeChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const homeCountryQuery = useHomeCountry();

    const currencySymbolQuery = useCurrencySymbol();

    const trustBalanceQuery = useTrustBalanceByAgeQuery(
        {
            entityGuid: props.chartFilter?.entityGuid,
            entityType: props.chartFilter?.entityType,
            responsibility: props.chartFilter?.responsibility,
        },
        'network-only',
    );

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0,
    })[1];

    const [state, setState] = useState<ChartState>({
        balances: [],
        total: 0,
        homeCountry: 'AU',
        symbol: '$',
    });

    useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    useEffect(() => {
        if (
            homeCountryQuery.data &&
            homeCountryQuery.data.options &&
            !homeCountryQuery.loading &&
            !homeCountryQuery.error
        ) {
            const { stringValue } = homeCountryQuery!.data.options.homeCountry;

            setState((prevState) => {
                return {
                    ...prevState,
                    homeCountry: stringValue ?? state.homeCountry
                };
            });
        }
        // tslint:disable-next-line: align
    }, [homeCountryQuery.data, homeCountryQuery.loading, homeCountryQuery.error]);

    useEffect(() => {
        if (trustBalanceQuery.data && !trustBalanceQuery.error && !trustBalanceQuery.loading) {
            setState((prevState) => {
                const { trustBalancesByAge } = trustBalanceQuery.data!.statistics.matter;
                const tempTotal = trustBalancesByAge.total;
                const tempBalances = trustBalancesByAge.balances;
                return {
                    ...prevState,
                    balances: tempBalances,
                    total: tempTotal,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [trustBalanceQuery.data, trustBalanceQuery.error, trustBalanceQuery.loading]);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isTustBalanceByAgeChartOpen`);
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize();
        }
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1;
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };

    const onScrollDownAndNext = (type: 'down' | 'next') => {
        const labels = state.balances.map((balance: Balance) => balance.format);

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        } else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        }
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {
        const labels = state.balances.map((balance: Balance) => balance.format);
        // up
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onZoom = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Trust Account Balance by Last Transaction Age'));
            // tslint:disable-next-line: align
        }, 500);
    };

    const chartControllerComponent = () => {
        return (
            <>
<IconButtonWrapper aria-label="close">
                    <ChartInfo description={props.description} fontSize={props.showAllRecords ? 'large' : 'medium'} className={`${classes.helpIcon} rv-chart-help`} />
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push({ property: 'TrustBalance', operator: 'gt', comparison: '0' });
            searchCriterias.push({ property: 'LastTrustTransactionDate', operator: 'isnot', comparison: 'null' });

            props.getSelectedItem(
                searchCriterias,
                true,
                `${getChartTitle(state.homeCountry)}`,
                DrillDownType.matterSummaryDrilldown,
                'Trust/Client Funds',
            );
        }
    };

    const getChartTitle = (homeCountry: string) => {
        var title = 'Dormant Trust Account Matters';

        if (homeCountry !== 'AU') {
            title = 'Dormant Client Account Matters';
        }

        return title;
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    if (currencySymbolQuery.loading || trustBalanceQuery.loading || homeCountryQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    let chartData: number[] = state.balances.map((balance) => balance.balance);
    let chartLabel: string[] = state.balances.map((balance) => balance.format);
    let total: number = state.total;

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(chartData) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<AccountBalanceOutlinedIcon />} title={getChartTitle(state.homeCountry)} />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={total} format={(amount) => `${state.symbol}${formatNumber(amount)}`} />
                </div>
                <div className={classes.titleBy}>Balance By Last Transaction Age</div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton size="medium" onClick={onScollBar('up')} ref={scrollUpAndPrevRef}>
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton size="medium" onClick={onScollBar('down')} ref={scrollDownAndNextRef}>
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const grouping = state.balances.map((balance: Balance) => balance.grouping)[_index];

                            const format = state.balances.map((balance: Balance) => balance.format)[_index];

                            const searchCriterias = new Array<SearchCriteria>();

                            searchCriterias.push({ property: 'TrustBalancesByAge', operator: '', comparison: grouping });

                            // searchCriterias.push({ property: 'TrustBalancesByAge', operator: 'eq', comparison: convertFirstLetterToUppercase(state.option) });

                            props.getSelectedItem(
                                searchCriterias,
                                true,
                                `${getChartTitle(state.homeCountry)} | ${format}`,
                                DrillDownType.matterSummaryDrilldown,
                                'Trust/Client Funds',
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(chartLabel),
                        datasets: [
                            {
                                label: 'Balance',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: chartData,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(chartData),
                                beginAtZero: true,
                                ticks: {
                                        ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(chartData),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number | string, index: number, ticks: Tick[]) {
                                        return `${state.symbol}${formatNumber(Number(tickValue))}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                max: props.showAllRecords ? 29 : 9,
                                ticks: {
                                        ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                },
                            },
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return [`${dataset.label}: ${state.symbol}${formatNumber(currentValue)}`];
                                    },
                                    // tslint:disable-next-line: no-any
                                    afterLabel: function (context: any) {
                                        const { dataIndex } = context;

                                        const matters = state.balances.map((balance: Balance) => balance.matters)[dataIndex];

                                        return [`Matters: ${formatNumber(matters)}`];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(chartData) && (
                    <ChartEmptyState title="No dormant trust balances" hint={"There are no dormant trust account matters."} />
                )}
            </div>
            {state.balances.length >= 10 && (
                <ChartLimitNote>The top 10 are shown</ChartLimitNote>
            )}
        </div>
    );
};
